import * as React from 'react';
import styled from 'styled-components';
import MuiCheckbox, { CheckboxProps as MuiCheckboxProps } from '@material-ui/core/Checkbox';

const StyledCheckbox = styled(MuiCheckbox)``;

export type DSCheckboxProps = Omit<MuiCheckboxProps, 'component'> & { ['data-cy']?: string };
export const DSCheckbox: React.FC<DSCheckboxProps> = props => <StyledCheckbox {...props} />;
DSCheckbox.displayName = 'DSCheckbox';
